<script>
	import articleTabMixin from 'mixins/article-tab';

	export default {
		mixins: [articleTabMixin],
		props: ['article'],
		modelData: ['offlineMode', 'printing', 'contentSection'],
		components: {
			'vocab-rate-words': require('components/vocab-rate-words.vue').default,
			'vocab-changer-activity': require('components/vocab-changer-activity.vue').default,
			'vocab-builder-activity': require('components/vocab-builder-activity.vue').default,
			'vocab-matcher-activity': require('components/vocab-matcher-activity.vue').default,
			'article-selection': require('components/article-selection.vue').default
		},
		computed: {
			showTts() {
				return this.offlineMode === false && !!this.article;
			}
		},
		methods: {
			setArticleList() {
				const article = this.article;
				const articleList = article && article.articleList;

				if (articleList && !article.sr && article.productType !== 'P') {
					this.articleList = articleList.filter(a => a.vocab && a.vocab.activity);
				}
			}
		},
		created() {
			const article = this.selectedArticle;
			const hasVocabActivity = !!(article.vocab && article.vocab.activity);

			if (!hasVocabActivity) {
				if (this.articleList) {
					this.contentSection = this.articleList[0].uuid;
				}
			}
		}
	};
</script>
<template>
	<div
		class="vocab-activity-tab"
		:class="{ printing: printing }"
		aria-live="polite">
		<article-selection
			v-if="articleList.length > 0"
			:article="article"
			:selected-article="selectedArticle"
			:article-list="articleList"
			@article-selected="onArticleSelect"></article-selection>
		<vocab-rate-words
			:show-tts="showTts"
			:product="article"
			:selected-product="selectedArticle"
			print-position="before"></vocab-rate-words>
		<hr v-if="printing" />
		<section
			v-if="selectedArticle.vocab.activity.word_builder"
			class="activity">
			<vocab-builder-activity
				:show-tts="showTts"
				:word-list="selectedArticle.vocab.support.word_list"
				:word-builder="selectedArticle.vocab.activity.word_builder"
				:product-id="selectedArticle.uuid"></vocab-builder-activity>
		</section>
		<section
			v-if="selectedArticle.vocab.activity.word_matcher"
			class="activity">
			<vocab-matcher-activity
				:show-tts="showTts"
				:product="article"
				:selected-product="selectedArticle"
				:word-list="selectedArticle.vocab.support.word_list"
				:word-matcher="selectedArticle.vocab.activity.word_matcher"></vocab-matcher-activity>
		</section>
		<section
			v-if="selectedArticle.vocab.activity.word_changer"
			class="activity">
			<vocab-changer-activity
				:show-tts="showTts"
				:product="article"
				:selected-product="selectedArticle"
				:word-list="selectedArticle.vocab.support.word_list"
				:word-changer="selectedArticle.vocab.activity.word_changer"></vocab-changer-activity>
		</section>
		<template v-if="printing">
			<hr />
			<vocab-rate-words
				:product="article"
				:selectedProduct="selectedArticle"
				print-position="after"></vocab-rate-words>
		</template>
	</div>
</template>
